import { FC } from "react";
import classNames from "classnames";
import styles from "./styles.module.scss";

/**
 * A table cell tail.
 */
export const TableCellTail: FC = () => {
  return (
    <td className={classNames(styles.TableCell, "table-cell", "tail")}>
      <div className="cell-outer-content"><div className="cell-inner-content" /></div>
    </td>
  );
};
